import styled from '@emotion/styled';
import { useCompanyUserRegistrationAuth } from './useCompanyUserRegistrationAuth';

const Wrapper = styled.div`
    margin: 0 auto;
    padding: 40px 30px;
    border-radius: 12px;
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-size: var(--font-medium);
    text-align: center;
`;

const Title = styled.div`
    font-size: var(--font-xxx-large);
    color: var(--main-color-blue);
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
`;

const CompleteText = styled.div`
    margin: 0;
    font-size: var(--font-medium);
    line-height: 1.5;
`;

export const CompanyUserRegistrationAuth: React.FC = () => {
    const { complete, authError, isLoggedIn } = useCompanyUserRegistrationAuth();

    return (
        <Wrapper>
            {!complete ? (
                <>
                    <Title>認証中です</Title>
                    <CompleteText>認証中です。しばらくお待ちください。</CompleteText>
                </>
            ) : isLoggedIn ? (
                <>
                    <Title>現在別のユーザーでログイン中です。</Title>
                    <CompleteText>一度ログアウトしてから再度お試しください。</CompleteText>
                </>
            ) : authError ? (
                <>
                    <Title>認証に失敗しました</Title>
                    <CompleteText>認証に失敗しました。URLが無効です。</CompleteText>
                </>
            ) : (
                <>
                    <Title>認証が完了しました</Title>
                    <CompleteText>認証が完了しました。パスワード設定画面に移動します。</CompleteText>
                </>
            )}
        </Wrapper>
    );
};
